import React from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
export const Cart = ({setShowCart}) => {
  return (
    <div className="bg-[#F0F0F0] dark:bg-[#1C1C1C] p-4 w-[350px] md:w-[400px] rounded-lg">
      <div className="flex items-center justify-between space-x-4">
        <h1 className="text-xl">Your Cart (2)</h1>
        <button className="" onClick={() => setShowCart(prev => !prev)}><IoClose className="text-xl"/></button>
      </div>
      <hr className="my-4 border-[#D3D3D3] dark:border-gray-500" />
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img
           className="w-[52px] h-[48px] rounded-lg"
            src="https://images.pexels.com/photos/13070618/pexels-photo-13070618.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
          <div>
            <p>Atro Figma Mobile UI Kit</p>
            <p>UI Kits</p>
          </div>
        </div>
        <div>
          <p>$39</p>
          <FaRegTrashAlt className="text-red-500  border-[2px] border-[#D3D3D3] dark:border p-2 text-3xl rounded-md" />
        </div>
      </div>
      <hr className="my-4 border-[#D3D3D3] dark:border-gray-500" />
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img
            className="w-[52px] h-[48px] rounded-lg"
            src="https://images.pexels.com/photos/27260680/pexels-photo-27260680/free-photo-of-red-flower.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
          <div>
            <p>Atro Figma Mobile UI Kit</p>
            <p>UI Kits</p>
          </div>
        </div>
        <div>
          <p>$39</p>
          <FaRegTrashAlt className="text-red-500 border-[2px] border-[#D3D3D3] dark:border p-2 text-3xl rounded-md" />
        </div>
      </div>
      <hr className="my-4 border-[#D3D3D3] dark:border-gray-500" />
      <div>
        <div className="flex items-center justify-between">
          <p>Cart items</p>
          <p>$78</p>
        </div>
        <div className="flex items-center justify-between">
          <p>VAT (19%)</p>
          <p>$11.98</p>
        </div>
        <div className="flex items-center justify-between">
          <p>Total to pay</p>
          <p>$98.97</p>
        </div>
        <a href="/Pages/Checkout">

        <button className="bg-[#1C1C1C] text-white dark:bg-white dark:text-black w-full rounded-xl py-3 mt-4">Checkout</button>
        </a>
      </div>
    </div>
  );
};
